import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import SessionMgt from '../../components/SessionMgt';
import { isAuthApi } from '../apiLogin';
import { getBasePath } from '../../utils';
import { getSettings, clearSettings } from '../../actions/settingsActions';
import {
	setAccountRealms,
	setAuthorisedCategories,
} from '../../actions/authActions';

export const getAuthorizedRoutes = (accessCategories) => {
	const allCategories = {
		shopping: 'shopping',
		managebookings: 'booking',
		customeraccount: 'accounts',
		campaignmgt: 'campaigns',
		ouigovouchersmgt: 'ouigorefunds',
		admin: 'admin',
	};
	return (accessCategories || '')
		.split(',')
		.filter((category) => allCategories[category])
		.map((category) => allCategories[category]);
};

export const getRouteFromPath = (pathname = '') =>
	pathname.replace(getBasePath(), '').split('/').filter(Boolean)[0];

export const isAuthorizedOuigoRefundsRoute = (pathname, authorizedRoutes) => {
	const route = getRouteFromPath(pathname);
	return route !== 'ouigorefunds' || authorizedRoutes.includes('ouigorefunds');
};

export const getDefaultAuthorizedPath = (authorizedRoutes) =>
	`${getBasePath()}${authorizedRoutes[0] || 'login'}`;

function SecureRoute({
	getSettings: onGetSettings,
	history,
	clearSettings: onClearSettings,
	settings,
	setAccountRealms: onSetAccountRealms,
	setAuthorisedCategories: onSetAuthorisedCategories,
	children,
	...rest
}) {
	const [isAuthenticated, setIsAuthenticated] = useState();
	const [authorizedRoutes, setAuthorizedRoutes] = useState([]);

	useEffect(() => {
		isAuthApi(
			() => {
				setIsAuthenticated(false);
			},
			(response) => {
				if (response?.successResponse?.data?.SecurityAuthenticated === 'true') {
					onSetAccountRealms(
						response.successResponse.data.SecurityAuthenticationRealms,
					);
					onGetSettings();
					const routes = getAuthorizedRoutes(
						response.successResponse.data.SecurityAuthorizedCategories,
					);
					setAuthorizedRoutes(routes);
					onSetAuthorisedCategories(
						response.successResponse.data.SecurityAuthorizedCategories,
					);
					setIsAuthenticated(true);
					if (routes.indexOf('shopping') === -1) {
						history.replace(
							window.location.state?.from || getDefaultAuthorizedPath(routes),
						);
					}
				} else {
					onClearSettings();
					setIsAuthenticated(false);
				}
			},
		);
	}, []);

	const renderRoute = ({ location }) => {
		if (!isAuthenticated) {
			return (
				<Redirect
					to={{
						pathname: `${getBasePath()}login`,
						state: { from: location },
					}}
				/>
			);
		}

		if (!isAuthorizedOuigoRefundsRoute(location.pathname, authorizedRoutes)) {
			return <Redirect to={getDefaultAuthorizedPath(authorizedRoutes)} />;
		}

		return children;
	};

	return (
		!!settings.size &&
		isAuthenticated !== undefined && (
			<>
				<SessionMgt />
				<Route history={history} {...rest} render={renderRoute} />
			</>
		)
	);
}

SecureRoute.propTypes = {
	children: PropTypes.node,
	getSettings: PropTypes.func,
	clearSettings: PropTypes.func,
	setAccountRealms: PropTypes.func,
	setAuthorisedCategories: PropTypes.func,
	settings: PropTypes.object,
	history: PropTypes.object,
};

const mapStateToProps = (state) => ({
	settings: state.get('settings'),
	accessCategories: state.get('ws.system.security.auth_access_categories'),
});

const mapDispatchToProps = {
	getSettings,
	clearSettings,
	setAccountRealms,
	setAuthorisedCategories,
};

export default connect(mapStateToProps, mapDispatchToProps)(SecureRoute);
